module.exports = __webpack_public_path__ + "static/media/teafloor2.eb84ca2c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/teafloor2.jpg
// module id = 453
// module chunks = 0